<template>
  <div>

    <div class="row mx-1 mt-1">
      <b-select v-model="perPage" :options="pageOptions" class="pageSizeClass">
      </b-select>
    </div>
    <b-table 
      :items="applyActivities"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :per-page="perPage"
      :current-page="currentPage"
      responsive
      show-empty
      ref="evaluationsTable"
      class="mt-2"
      thead-class="esep-blue-bg text-light"
    >      
      <template v-slot:cell(action)="row">
        <b-button
          size="sm"
          @click="goToEvaluation(row.item)"
          variant="transparent"
          v-b-tooltip.hover
          :title="$t('evaluations.goToEvaluation')"
        >
          <b-icon icon="box-arrow-right" ></b-icon>
        </b-button>
      </template>

      <template v-slot:empty="">
        <h6>{{ $t("evaluations.emptyEvaluationsTable") }}</h6>
      </template>

      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>

    </b-table>

    <b-row>
      <b-col>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="evaluations-table"
          variant="info"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  computed: {
    rows() {
      return this.applyActivities? this.applyActivities.length : 0;
    }
  },
  props: {
    applyActivities: Array
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      pageOptions: [
        10,
        20,
        50,
        {
          value: Number.MAX_SAFE_INTEGER,
          text: "All",
        },
      ],
      sortBy: "member",
      sortDesc: false,
      fields: [
        { key: "dateCreated", label: "Ημ. Δημιουργίας", sortable: true, formatter: 'showDate' },
        { key: "module.title", label: "Εκπ. Ενότητα", sortable: true }, // needs to be translated
        { key: "member", label: "Εκπαιδευόμενος", sortable: true , filterByFormatted: true, formatter: 'showValidator', thClass: 'text-left', tdClass: 'text-left'},
        { key: "dateAssigned", label: "Ημ. Ανάθεσης", sortable: true, formatter: 'showDate' },
        { key: "action", label: "Ενέργειες", sortable: false },
      ]
    }
  },
  methods: {
    showTitle(mod) {
      return mod.title;
    },
    showValidator(validator) {
      return validator? validator.surName + ' ' + validator.firstName: '-';
    },
    showDate(datetime) {
      return new Date(datetime).toLocaleString();
    },
    goToEvaluation(activity) {
      window.location.href = `/app/training/web/apply-activities/${activity.id}`;
    } 
  }
}
</script>